import { Injectable } from '@angular/core';
import { HttpProvider } from './http/http.provider';
import { UserProgramInfo } from '../store/normalized/schemas/user.schema';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserProgramInfoProvider {

  private userProgramEndpoint = '/user_program_info';

  constructor(
    protected http: HttpProvider
  ) {
  }

  updateUserProgramInfo(payload: UserProgramInfo) {
    return this.http.patch(this.userProgramEndpoint, payload);
  }

  getUserProgramInfo(): Observable<UserProgramInfo> {
    return this.http.get<UserProgramInfo>(this.userProgramEndpoint);
  }

}
